/**
 * Restoring the camera after a WebXR session ends.
 *
 * From PlayCanvas 2.23 the XR manager follows the camera's near / far clip (`set:nearClip`,
 * `set:farClip`) while a session runs, and stops listening only after it has fired 'end'
 * (framework/xr/xr-manager.js, onEnd). A clip change made from an 'end' handler is therefore
 * pushed into the session that has just ended, and the browser throws "XRSession has already
 * ended.", which aborts the rest of the handler (camera controls, budgets, the xrEnd event).
 * 2.21 listened for `set_nearClip`, which the camera never fired, so the same code was safe.
 */

/** Set the camera's near clip once the engine has finished ending the session (a microtask later). */
export function restoreNearClipAfterXrEnd(camera: { nearClip: number }, nearClip: number, alive: () => boolean): void {
    queueMicrotask(() => {
        if (alive()) camera.nearClip = nearClip;
    });
}
